"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AddGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.982 9.85l.001-.096a5.587 5.587 0 00-10.21-3.138 4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1c5.987 0 10.863 4.792 10.997 10.747a7.252 7.252 0 00-3.015-1.897z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.665 15.206a7.278 7.278 0 00-.165 1.544 7.244 7.244 0 003.328 6.099 11.06 11.06 0 01-6.423-.853v-3.14c0-1.44.586-2.953 3.26-3.65zm1.35-2.893a3.496 3.496 0 115.867-2.812L17.75 9.5a7.238 7.238 0 00-5.734 2.813zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm1-6.188v-2.437h-2v2.438h-2.438v2h2.438v2.437h2v-2.438h2.438v-2H18.75z"
  })));
});
AddGroupIcon.category = 'Profile';
var _default = AddGroupIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/AddGroupIcon.js
// module id = 1038
// module chunks = 0